import React from 'react'
import i18next from 'i18next'
import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import { StyleSheetManager } from 'styled-components';
import stylisRTL from 'stylis-plugin-rtl';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// The app's css is written right-to-left: `text-align: right` means "the side
// the text starts on", and the margins and offsets follow. That reads correctly
// in Hebrew and backwards in English, so for English every rule is mirrored on
// its way into the stylesheet. Hebrew gets no plugin at all, so its styles come
// out exactly as they always have.
//
// Declarations that must not move either way - the `direction: ltr` that keeps
// phone numbers and email addresses running left to right - are marked
// /* @noflip */ where they are written.
const isHebrew = (language?: string) => !language || language.startsWith('he')

function RTL(props: any) {
  return (
    <StyleSheetManager stylisPlugins={isHebrew(i18next.language) ? [] : [stylisRTL]}>
      <StylesProvider jss={jss}>
        {props.children}
      </StylesProvider>
    </StyleSheetManager>
  );
}

export default RTL
